export const teams = [
  { label: 'Athletic', id: 'Athletic Club', active: true },
  { label: 'Atleti', id: 'Club Atlético de Madrid', active: true },
  { label: 'Osasuna', id: 'CA Osasuna', active: true },
  { label: 'Espanyol', id: 'RCD Espanyol de Barcelona', active: true },
  { label: 'Barça', id: 'FC Barcelona', active: true },
  { label: 'Getafe', id: 'Getafe CF', active: true },
  { label: 'Real Madrid', id: 'Real Madrid CF', active: true },
  { label: 'Rayo Vallecano', id: 'Rayo Vallecano de Madrid', active: true },
  { label: 'Levante', id: 'Levante UD', active: true },
  { label: 'Real Betis', id: 'Real Betis Balompié', active: true },
  { label: 'Real Sociedad', id: 'Real Sociedad de Fútbol', active: true },
  { label: 'Villarreal', id: 'Villarreal CF', active: true },
  { label: 'Valencia', id: 'Valencia CF', active: true },
  { label: 'Alavés', id: 'Deportivo Alavés', active: true },
  { label: 'Elche', id: 'Elche CF', active: true },
  { label: 'Celta', id: 'RC Celta de Vigo', active: true },
  { label: 'Sevilla FC', id: 'Sevilla FC', active: true },
  { label: 'Málaga', id: 'Málaga CF', active: true },
  { label: 'Deportivo', id: 'RC Deportivo La Coruña', active: true },
  { label: 'Santander', id: 'Real Racing Club de Santander', active: true }
];